import {Component, Input, OnInit} from '@angular/core';
import {UserPrivilegeDTO} from '../../../../shared/dto/user-privilege.model';

@Component({
  selector: 'app-user-privilege-table',
  templateUrl: './user-privilege-table.component.html',
  styleUrls: ['./user-privilege-table.component.scss']
})
export class UserPrivilegeTableComponent implements OnInit {
  @Input() data:  UserPrivilegeDTO[];
  constructor() { }

  ngOnInit() {
  }

  onDelete(i){
    this.data.splice(i,1);
  }

}
